/* header.js - predictive search suggestions and the mobile menu disclosure.
   Suggestions come from Shopify's predictive search JSON endpoint. The engine
   pads results with unrelated popular products, so the same relevance rule the
   search page applies server side is applied here client side: a product is
   kept only when a query word of 2+ characters appears in its title or handle. */
(function () {
  var DEBOUNCE_MS = 220;

  function relevant(items, words) {
    if (!words.length) return items;
    return items.filter(function (item) {
      var hay = ((item.title || '') + ' ' + (item.handle || '')).toLowerCase();
      return words.some(function (w) { return hay.indexOf(w) !== -1; });
    });
  }

  function row(item, kind) {
    var a = document.createElement('a');
    a.className = 'site-header__suggest-row';
    a.href = item.url;
    a.setAttribute('role', 'option');
    if (item.image) {
      var img = document.createElement('img');
      img.src = item.image;
      img.alt = '';
      img.width = 40;
      img.height = 25;
      img.loading = 'lazy';
      a.appendChild(img);
    }
    var text = document.createElement('span');
    text.className = 'site-header__suggest-text';
    var title = document.createElement('span');
    title.className = 'site-header__suggest-title';
    title.textContent = item.title;
    text.appendChild(title);
    var meta = document.createElement('span');
    meta.className = 'site-header__suggest-meta';
    meta.textContent = kind;
    text.appendChild(meta);
    a.appendChild(text);
    return a;
  }

  class SearchSuggestElement extends HTMLElement {
    constructor() {
      super();
      this.onDocumentClickBound = this.onDocumentClick.bind(this);
    }

    connectedCallback() {
      this.input = this.querySelector('[data-suggest-input]');
      this.panel = this.querySelector('[data-suggest-panel]');
      this.form = this.querySelector('form');
      this.defaults = this.querySelector('[data-suggest-defaults]');
      this.suggestUrl = this.dataset.suggestUrl || '/search/suggest';
      this.timer = null;
      this.controller = null;
      this.activeIndex = -1;
      if (!this.input || !this.panel) return;

      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      document.addEventListener('click', this.onDocumentClickBound);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClickBound);
    }

    open() { this.panel.hidden = false; this.input.setAttribute('aria-expanded', 'true'); }

    close() {
      // Cancel any debounce timer or in-flight fetch so neither can call
      // render()->open() after the panel has been explicitly dismissed
      // (e.g. Escape or outside-click shortly after a keystroke).
      clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.activeIndex = -1;
    }

    options() { return Array.prototype.slice.call(this.panel.querySelectorAll('[role="option"]')); }

    onFocus() {
      if (this.input.value.trim() || !this.defaults) return;
      this.panel.innerHTML = '';
      var wrap = document.createElement('div');
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-labelledby', 'header-suggest-head-default');
      var head = document.createElement('p');
      head.className = 'site-header__suggest-head';
      head.id = 'header-suggest-head-default';
      head.textContent = 'Popular destinations';
      wrap.appendChild(head);
      var chips = document.createElement('div');
      chips.className = 'site-header__suggest-chips';
      chips.appendChild(this.defaults.content.cloneNode(true));
      wrap.appendChild(chips);
      this.panel.appendChild(wrap);
      this.open();
    }

    onInput() {
      var q = this.input.value.trim();
      clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
      if (q.length < 2) { this.close(); return; }
      this.timer = setTimeout(this.fetchSuggestions.bind(this, q), DEBOUNCE_MS);
    }

    fetchSuggestions(q) {
      this.controller = new AbortController();
      var url = this.suggestUrl + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,article,page&resources[limit]=5';
      var self = this;
      fetch(url, { signal: this.controller.signal })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (data) { self.render(q, (data.resources && data.resources.results) || {}); })
        .catch(function () { /* aborted or offline: leave the panel as it is */ });
    }

    render(q, results) {
      var words = q.toLowerCase().split(' ').filter(function (w) { return w.length >= 2; });
      var products = relevant(results.products || [], words);
      // Shopify's predictive search JSON names this field `type` (not
      // `product_type` as in the Liquid product object) - verified against
      // the live /search/suggest.json payload before relying on it here.
      var singles = products.filter(function (p) { return p.type !== 'Multi-country'; });
      var packs = products.filter(function (p) { return p.type === 'Multi-country'; });
      var articles = (results.articles || []).slice(0, 3);

      this.panel.innerHTML = '';
      var groups = [
        { label: 'Destinations', items: singles, kind: 'eSIM' },
        { label: 'Regional packs', items: packs, kind: 'Multi country' },
        { label: 'Guides', items: articles, kind: 'Guide' }
      ];
      var any = false;
      var self = this;
      var groupIndex = 0;
      groups.forEach(function (group) {
        if (!group.items.length) return;
        any = true;
        groupIndex += 1;
        var headId = 'header-suggest-head-' + groupIndex;
        var wrap = document.createElement('div');
        wrap.setAttribute('role', 'group');
        wrap.setAttribute('aria-labelledby', headId);
        var head = document.createElement('p');
        head.className = 'site-header__suggest-head';
        head.id = headId;
        head.textContent = group.label;
        wrap.appendChild(head);
        group.items.forEach(function (item) { wrap.appendChild(row(item, group.kind)); });
        self.panel.appendChild(wrap);
      });

      var all = document.createElement('a');
      all.className = 'site-header__suggest-all';
      all.setAttribute('role', 'option');
      all.href = this.form.action + '?options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
      all.textContent = any ? 'See all results for "' + q + '"' : 'Search for "' + q + '"';
      this.panel.appendChild(all);
      this.activeIndex = -1;
      this.open();
    }

    setActive(index) {
      var opts = this.options();
      if (!opts.length) return;
      if (index < 0) index = opts.length - 1;
      if (index >= opts.length) index = 0;
      opts.forEach(function (o) { o.removeAttribute('aria-selected'); o.classList.remove('is-active'); });
      opts[index].setAttribute('aria-selected', 'true');
      opts[index].classList.add('is-active');
      this.activeIndex = index;
    }

    onKeydown(event) {
      if (event.key === 'Escape') { this.close(); this.input.focus(); return; }
      if (this.panel.hidden) return;
      if (event.key === 'ArrowDown') { event.preventDefault(); this.setActive(this.activeIndex + 1); return; }
      if (event.key === 'ArrowUp') { event.preventDefault(); this.setActive(this.activeIndex - 1); return; }
      if (event.key === 'Enter' && this.activeIndex >= 0) {
        var opts = this.options();
        if (opts[this.activeIndex]) { event.preventDefault(); window.location.href = opts[this.activeIndex].href; }
      }
    }

    onDocumentClick(event) { if (!this.contains(event.target)) this.close(); }
  }

  if (!customElements.get('tsa-search-suggest')) {
    customElements.define('tsa-search-suggest', SearchSuggestElement);
  }

  // Moved here from cart-drawer.js (Phase 1 carry-forward 8): the header's
  // <details data-menu-disclosure> has no built in close on outside click.
  document.addEventListener('click', function (event) {
    var openMenus = document.querySelectorAll('details[data-menu-disclosure][open]');
    for (var i = 0; i < openMenus.length; i++) {
      if (!openMenus[i].contains(event.target)) openMenus[i].removeAttribute('open');
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var openMenus = document.querySelectorAll('details[data-menu-disclosure][open]');
    for (var i = 0; i < openMenus.length; i++) {
      openMenus[i].removeAttribute('open');
    }
  });
})();

(function () {
  // Sticky compact header. The nav row scrolls away normally; only the
  // compact row (.site-header__row: logo, search, cart) pins to the top.
  // A sticky child only sticks within its parent's box, and the pure CSS
  // trick (sticky parent with a negative top) only works when the row to
  // hide comes first in DOM order, which it does not here (nav is second),
  // so this toggles a class and the row switches to position: fixed.
  var header = document.querySelector('.site-header');
  var row = header ? header.querySelector('.site-header__row') : null;
  if (!header || !row) return;

  var rowHeightUnstuck = 0;
  var ticking = false;

  // The row is a different height depending on whether it is stuck: below
  // 47.9rem the unstuck layout wraps the search onto its own line (tall),
  // while the stuck layout uses the compact mark and keeps everything on
  // one line (short). A single measurement is not enough - offsetHeight
  // only reflects whichever state the row happens to be in at the moment
  // measure() runs, which right after a resize could be either one. Both
  // states are measured explicitly here, each with the class forced into
  // the state it reports on, so the values are correct regardless of the
  // row's current state when measure() is called.
  //
  // --header-height-unstuck feeds the reserved padding-top on
  // .site-header.is-stuck: that padding needs to equal what the row
  // occupied in normal flow the instant before it pinned, so when the row
  // leaves flow for position: fixed, the padding fills the exact space it
  // vacated and nothing on the page shifts.
  //
  // --header-height feeds the row's own fixed-position rendering and the
  // external elements offset from the header (tsa-faq, tsa-product-shell):
  // those need the height the row actually renders at once pinned, not the
  // taller pre-pin figure, or they would float too low / leave a gap.
  function measure() {
    var wasStuck = header.classList.contains('is-stuck');

    header.classList.remove('is-stuck');
    rowHeightUnstuck = row.offsetHeight;

    header.classList.add('is-stuck');
    var rowHeightStuck = row.offsetHeight;

    // Forcing both classes above causes synchronous reflows but no paint
    // happens until this function returns, so restoring the real state
    // here does not flicker.
    header.classList.toggle('is-stuck', wasStuck);

    document.documentElement.style.setProperty('--header-height-unstuck', rowHeightUnstuck + 'px');
    document.documentElement.style.setProperty('--header-height', rowHeightStuck + 'px');
  }

  function updateStuck() {
    header.classList.toggle('is-stuck', window.scrollY > rowHeightUnstuck);
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateStuck);
  }

  function onResize() {
    measure();
    updateStuck();
  }

  measure();
  updateStuck();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
})();
